import { render, staticRenderFns } from "./RankingQuestion.vue?vue&type=template&id=51df02b2&scoped=true&"
import script from "./RankingQuestion.vue?vue&type=script&lang=js&"
export * from "./RankingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./RankingQuestion.vue?vue&type=style&index=0&id=51df02b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df02b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
